import parseAPNG, { isNotAPNG } from 'apng-js';

export default function isNotPng(buffer) {
  const apng = parseAPNG(buffer);
  console.log(apng)
  if (apng instanceof Error) {
    return !isNotAPNG(apng);
  }

  return true;
}